// Chakra imports
import {
	Avatar,
	AvatarBadge,
	AvatarGroup,
	Box,
	Button,
	CircularProgress,
	CircularProgressLabel,
	DarkMode,
	Flex,
	Grid,
	Icon,
	Image,
	Link,
	Switch,
	Text,
	Tooltip,
} from '@chakra-ui/react';
import avatar11 from 'assets/img/avatars/avatar11.png';
// Images
import avatar2 from 'assets/img/avatars/avatar2.png';
import avatar3 from 'assets/img/avatars/avatar3.png';
import avatar4 from 'assets/img/avatars/avatar4.png';
import avatar6 from 'assets/img/avatars/avatar6.png';
import bgProfile from 'assets/img/bgProfile.png';
import ProjectImage1 from 'assets/img/ProjectImage1.png';
import ProjectImage2 from 'assets/img/ProjectImage2.png';
import ProjectImage3 from 'assets/img/ProjectImage3.png';
// Custom components
import Card from 'components/Card/Card';
import CardBody from 'components/Card/CardBody';
import CardHeader from 'components/Card/CardHeader';
import LineChart from 'components/Charts/LineChart';
import IconBox from 'components/Icons/IconBox';
import { CarIcon, FulgerIcon, FulgerWhiteIcon } from 'components/Icons/Icons';
import { Separator } from 'components/Separator/Separator';
import React, { useState, useEffect } from 'react';
import { BsArrowRight } from 'react-icons/bs';
import { FaCube, FaFacebook, FaInstagram, FaPencilAlt, FaPenFancy, FaTwitter } from 'react-icons/fa';
// Icons
import { IoDocumentsSharp } from 'react-icons/io5';
import { FaClock, FaFileAlt, FaEdit } from 'react-icons/fa';

import { useParams } from 'react-router-dom';
import { useFetchData } from 'apiService';
import moment from 'moment';
import config from 'config';
import utils from 'utils';


function Profile() {

	// Get profile from id
	const { id } = useParams();
	const { data: users } = useFetchData(`userProfile/${id ? id : 0}`);
	const [user, setUser] = useState(null);

	useEffect(() => {
		if (users && users.length > 0) {
			setUser(users[0]);
		}
	}, [users]);

	return (
		<Flex direction='column' mt={{ sm: '25px', md: '0px' }}>
			<Box
				mb={{ sm: '24px', md: '50px', xl: '20px' }}
				borderRadius='15px'
				px='0px'
				display='flex'
				flexDirection='column'
				justifyContent='center'
				align='center'>
				{/* Header */}
				<Card
					direction={{ sm: 'column', md: 'row' }}
					mx='auto'
					maxH='330px'
					w={{ sm: '90%', xl: '100%' }}
					justifyContent={{ sm: 'center', md: 'space-between' }}
					align='center'
					p='24px'
					borderRadius='20px'
					mt='100px'>
					<Flex align='center' direction={{ sm: 'column', md: 'row' }}>
						<Flex
							align='center'
							mb={{ sm: '10px', md: '0px' }}
							direction={{ sm: 'column', md: 'row' }}
							w={{ sm: '100%' }}
							textAlign={{ sm: 'center', md: 'start' }}>
							<Avatar size="md" src={user ? user.avatar_url : null} w='80px' h='80px' borderRadius='15px' mr='20px'>
								{user && user.on_duty === 1 ? (
									<Tooltip label="En service" hasArrow>
										<AvatarBadge
											cursor='pointer'
											borderRadius='4px'
											border='transparent'
											bg='linear-gradient(126.97deg, #32CD32 28.26%, #008000 91.2%)'
											boxSize='13px'
											backdropFilter='blur(120px)'
										>
										</AvatarBadge>
									</Tooltip>
								) : (
									<Tooltip label="Hors service" hasArrow>
										<AvatarBadge
											cursor='pointer'
											borderRadius='4px'
											border='transparent'
											bg='linear-gradient(126.97deg, #FF0000 28.26%, #8B0000 91.2%)'
											boxSize='13px'
											backdropFilter='blur(120px)'
										>
										</AvatarBadge>
									</Tooltip>
								)}
							</Avatar>
							<Flex direction='column' maxWidth='100%' my={{ sm: '14px' }}>
								<Text
									fontSize={{ sm: 'lg', lg: 'xl' }}
									color='#fff'
									fontWeight='bold'
									ms={{ sm: '8px', md: '0px' }}>
									{user ? user.firstname + ' ' + user.name : 'l\'agent'}
								</Text>
								<Text fontSize={{ sm: 'sm', md: 'md' }} color='gray.400'>
									{user ? user.grade : 'N/A'}
								</Text>
							</Flex>
						</Flex>
						{/* BOUTONS A DROITE DU PROFIL; PEUT ETRE INTERESSANT
						<Flex direction={{ sm: 'column', lg: 'row' }} w={{ sm: '100%', md: '50%', lg: 'auto' }}>
							<Button
								borderRadius='12px'
								bg='brand.200'
								_hover={{ opacity: '0.8' }}
								_active={{ opacity: '0.9' }}
								me={{ base: 'none', lg: '20px' }}
								leftIcon={<Icon color='white' as={FaCube} me='6px' />}>
								<Text fontSize='xs' color='#fff' fontWeight='bold'>
									OVERVIEW
								</Text>
							</Button>
							<Button
								borderRadius='12px'
								bg='transparent'
								_hover={{
									bg: 'brand.200'
								}}
								_active={{
									bg: 'brand.200'
								}}
								me={{ base: 'none', lg: '20px' }}
								leftIcon={<Icon color='white' as={IoDocumentsSharp} me='6px' />}>
								<Text fontSize='xs' color='#fff' fontWeight='bold'>
									TEAMS
								</Text>
							</Button>
							<Button
								borderRadius='12px'
								bg='transparent'
								_hover={{
									bg: 'brand.200'
								}}
								_active={{
									bg: 'brand.200'
								}}
								leftIcon={<Icon color='white' as={FaPenFancy} me='6px' />}>
								<Text fontSize='xs' color='#fff' fontWeight='bold'>
									PROJECTS
								</Text>
							</Button>
						</Flex>
					*/}
					</Flex>
				</Card>
			</Box>
			{/* Statistiques rapides */}
			<Grid
				templateColumns={{
					sm: '1fr',
					md: 'repeat(2, 1fr)',
					xl: 'repeat(4, 1fr)'
				}}
				gap='16px'
				mb='24px'>
				{/* Stats Card - Procédures */}
				<Card p='16px'>
					<Flex align='center' justify='space-between'>
						<Flex direction='column'>
							<Text fontSize='xs' color='gray.400' mb='4px'>Procédures rédigées</Text>
							<Text fontSize='2xl' color='#fff' fontWeight='bold'>
								{user ? user.total_arrests : '0'}
							</Text>
						</Flex>
						<Flex
							w='45px'
							h='45px'
							bg='linear-gradient(135deg, #8b5cf6 0%, #a855f7 100%)'
							borderRadius='12px'
							align='center'
							justify='center'
						>
							<FaFileAlt size={18} color='white' />
						</Flex>
					</Flex>
				</Card>

				{/* Stats Card - Participations */}
				<Card p='16px'>
					<Flex align='center' justify='space-between'>
						<Flex direction='column'>
							<Text fontSize='xs' color='gray.400' mb='4px'>Participations à des interventions</Text>
							<Text fontSize='2xl' color='#fff' fontWeight='bold'>
								{user ? user.participated_arrests : '0'}
							</Text>
						</Flex>
						<Flex
							w='45px'
							h='45px'
							bg='linear-gradient(135deg, #06b6d4 0%, #0ea5e9 100%)'
							borderRadius='12px'
							align='center'
							justify='center'
						>
							<IoDocumentsSharp size={18} color='white' />
						</Flex>
					</Flex>
				</Card>

				{/* Stats Card - Temps en service */}
				<Card p='16px'>
					<Flex align='center' justify='space-between'>
						<Flex direction='column'>
							<Text fontSize='xs' color='gray.400' mb='4px'>Temps en service</Text>
							<Text fontSize='xl' color='#fff' fontWeight='bold'>
								{user ? utils.convertDuration(user.total_seconds_in_service) : '0h'}
							</Text>
						</Flex>
						<Flex
							w='45px'
							h='45px'
							bg='linear-gradient(135deg, #22c55e 0%, #14b8a6 100%)'
							borderRadius='12px'
							align='center'
							justify='center'
						>
							<FaClock size={18} color='white' />
						</Flex>
					</Flex>
				</Card>

				{/* Stats Card - Services */}
				<Card p='16px'>
					<Flex align='center' justify='space-between'>
						<Flex direction='column'>
							<Text fontSize='xs' color='gray.400' mb='4px'>Services effectués</Text>
							<Text fontSize='2xl' color='#fff' fontWeight='bold'>
								{user ? user.number_of_services : '0'}
							</Text>
						</Flex>
						<Flex
							w='45px'
							h='45px'
							bg='linear-gradient(135deg, #f97316 0%, #fb923c 100%)'
							borderRadius='12px'
							align='center'
							justify='center'
						>
							<FaEdit size={18} color='white' />
						</Flex>
					</Flex>
				</Card>
			</Grid>

			{/* Informations personnelles - Pleine largeur */}
			<Card p='20px' mb='24px'>
				<CardHeader p='0px' mb='16px'>
					<Flex align='center'>
						<Flex
							w='40px'
							h='40px'
							bg='linear-gradient(135deg, rgba(139, 92, 246, 0.2) 0%, rgba(168, 85, 247, 0.2) 100%)'
							borderRadius='10px'
							align='center'
							justify='center'
							mr='12px'
						>
							<Icon as={FaPencilAlt} color='purple.400' w={4} h={4} />
						</Flex>
						<Text fontSize='lg' color='#fff' fontWeight='bold'>
							Informations personnelles
						</Text>
					</Flex>
				</CardHeader>
				<CardBody p='0px'>
					<Grid templateColumns={{ sm: 'repeat(2, 1fr)', md: 'repeat(3, 1fr)', xl: 'repeat(6, 1fr)' }} gap='12px'>
						<Flex
							direction='column'
							p='12px'
							bg='rgba(255, 255, 255, 0.03)'
							borderRadius='10px'
						>
							<Text fontSize='xs' color='gray.500' mb='4px'>Rôle</Text>
							<Text fontSize='sm' color='#fff' fontWeight='500'>
								{user ? user.role || '-' : '-'}
							</Text>
						</Flex>
						<Flex
							direction='column'
							p='12px'
							bg='rgba(255, 255, 255, 0.03)'
							borderRadius='10px'
						>
							<Text fontSize='xs' color='gray.500' mb='4px'>Grade</Text>
							<Text fontSize='sm' color='#fff' fontWeight='500'>
								{user ? user.grade : '-'}
							</Text>
						</Flex>
						<Flex
							direction='column'
							p='12px'
							bg='rgba(255, 255, 255, 0.03)'
							borderRadius='10px'
						>
							<Text fontSize='xs' color='gray.500' mb='4px'>Secteur</Text>
							<Text fontSize='sm' color='#fff' fontWeight='500'>
								{user ? user.sector : '-'}
							</Text>
						</Flex>
						<Flex
							direction='column'
							p='12px'
							bg='rgba(255, 255, 255, 0.03)'
							borderRadius='10px'
						>
							<Text fontSize='xs' color='gray.500' mb='4px'>RIO / NIGEND</Text>
							<Text fontSize='sm' color='#fff' fontWeight='500'>
								{user ? user.nigend || '-' : '-'}
							</Text>
						</Flex>
						<Flex
							direction='column'
							p='12px'
							bg='rgba(255, 255, 255, 0.03)'
							borderRadius='10px'
						>
							<Text fontSize='xs' color='gray.500' mb='4px'>Téléphone</Text>
							<Text fontSize='sm' color='#fff' fontWeight='500'>
								{user ? user.phone || '-' : '-'}
							</Text>
						</Flex>
						<Flex
							direction='column'
							p='12px'
							bg='rgba(255, 255, 255, 0.03)'
							borderRadius='10px'
						>
							<Text fontSize='xs' color='gray.500' mb='4px'>Discord</Text>
							<Text fontSize='sm' color='#fff' fontWeight='500'>
								{user ? user.discord || '-' : '-'}
							</Text>
						</Flex>
					</Grid>
				</CardBody>
			</Card>

			{/* Résumé d'activité - Pleine largeur */}
			<Card p='20px' mb='24px'>
				<CardHeader p='0px' mb='16px'>
					<Flex align='center'>
						<Flex
							w='40px'
							h='40px'
							bg='linear-gradient(135deg, rgba(6, 182, 212, 0.2) 0%, rgba(14, 165, 233, 0.2) 100%)'
							borderRadius='10px'
							align='center'
							justify='center'
							mr='12px'
						>
							<Icon as={IoDocumentsSharp} color='cyan.400' w={4} h={4} />
						</Flex>
						<Text fontSize='lg' color='#fff' fontWeight='bold'>
							Résumé d'activité
						</Text>
					</Flex>
				</CardHeader>
				<CardBody p='0px'>
					<Text fontSize='sm' color='gray.400' lineHeight='1.8'>
						{user ? (
							<>
								<Text as='span' color='#fff' fontWeight='600'>{user.firstname} {user.name}</Text> est enregistré en tant que{' '}
								<Text as='span' color='#fff' fontWeight='600'>{user.grade}</Text> dans le secteur{' '}
								<Text as='span' color='#fff' fontWeight='600'>"{user.sector}"</Text> depuis le{' '}
								<Text as='span' color='#fff' fontWeight='500'>{moment(user.date_creation).format("D MMMM YYYY")}</Text>, 
								soit <Text as='span' color='#fff' fontWeight='600'>{moment().diff(moment(user.date_creation), 'days')} jours</Text>.
								<br /><br />
								Pendant cette période, l'agent a passé{' '}
								<Text as='span' color='#fff' fontWeight='600'>{utils.convertDuration(user.total_seconds_in_service)}</Text> en service, 
								réalisant <Text as='span' color='#fff' fontWeight='600'>{user.total_arrests} procédures</Text> et 
								participant à <Text as='span' color='#fff' fontWeight='600'>{user.participated_arrests} interventions</Text>.
							</>
						) : 'Chargement des informations...'}
					</Text>
				</CardBody>
			</Card>
			{/* POUR PLUS TARD, ça PEUT ÊTRE INTERESSANT
			<Grid templateColumns={{ sm: '1fr', xl: '1fr 3fr' }} gap='20px'>
				<DarkMode>
					<Card p='16px' gridArea={{ xl: '1 / 1 / 2 / 2' }}>
						<CardHeader p='12px 5px' mb='12px'>
							<Text fontSize='lg' color='#fff' fontWeight='bold'>
								Platform Settings
							</Text>
						</CardHeader>
						<CardBody px='5px'>
							<Flex direction='column'>
								<Text fontSize='10px' color={'gray.400'} mb='20px'>
									ACCOUNT
								</Text>
								<Flex align='center' mb='20px'>
									<Switch variant='brand' colorScheme='brand' me='10px' defaultChecked />
									<Text noOfLines={1} fontSize='sm' color={'gray.400'} fontWeight='400'>
										Email me when someone follows me
									</Text>
								</Flex>
								<Flex align='center' mb='20px'>
									<Switch colorScheme='brand' me='10px' />
									<Text noOfLines={1} fontSize='sm' color={'gray.400'} fontWeight='400'>
										Email me when someone answers on my post
									</Text>
								</Flex>
								<Flex align='center' mb='20px'>
									<Switch colorScheme='brand' me='10px' defaultChecked />
									<Text noOfLines={1} fontSize='sm' color={'gray.400'} fontWeight='400'>
										Email me when someone mentions me
									</Text>
								</Flex>
								<Text fontSize='10px' color={'gray.400'} m='6px 0px 20px 0px'>
									APPLICATION
								</Text>
								<Flex align='center' mb='20px'>
									<Switch colorScheme='brand' me='10px' />
									<Text noOfLines={1} fontSize='sm' color={'gray.400'} fontWeight='400'>
										New launches and projects
									</Text>
								</Flex>
								<Flex align='center' mb='20px'>
									<Switch colorScheme='brand' me='10px' defaultChecked />
									<Text noOfLines={1} fontSize='sm' color={'gray.400'} fontWeight='400'>
										Monthly product changes
									</Text>
								</Flex>
								<Flex align='center' mb='20px'>
									<Switch colorScheme='brand' me='10px' />
									<Text noOfLines={1} fontSize='sm' color={'gray.400'} fontWeight='400'>
										Subscribe to newsletter
									</Text>
								</Flex>
								<Flex align='center' mb='20px'>
									<Switch colorScheme='brand' me='10px' defaultChecked />
									<Text noOfLines={1} fontSize='sm' color={'gray.400'} fontWeight='400'>
										Receive mails weekly
									</Text>
								</Flex>
							</Flex>
						</CardBody>
					</Card>
				</DarkMode>

				<Card gridArea={{ xl: '1 /2 /2/ 5' }} p='16px'>
					<CardHeader p='12px 5px' mb='12px'>
						<Flex direction='column'>
							<Text fontSize='lg' color='#fff' fontWeight='bold'>
								Projects
							</Text>
							<Text fontSize='sm' color={'gray.400'} fontWeight='400'>
								Architects design houses
							</Text>
						</Flex>
					</CardHeader>
					<CardBody px='5px'>
						<Grid
							templateColumns={{
								sm: '1fr',
								md: '1fr 1fr',
								xl: 'repeat(3, 1fr)'
							}}
							templateRows={{
								sm: '1fr 1fr 1fr auto',
								md: '1fr 1fr',
								xl: '1fr'
							}}
							gap='24px'>
							<Flex direction='column'>
								<Box mb='20px' position='relative' borderRadius='20px'>
									<Image src={ProjectImage1} borderRadius='20px' />
								</Box>
								<Flex direction='column'>
									<Text fontSize='10px' color={'gray.400'} mb='10px'>
										Project #1
									</Text>
									<Text fontSize='xl' color='#fff' fontWeight='bold' mb='10px'>
										Modern
									</Text>
									<Text fontSize='sm' color={'gray.400'} fontWeight='400' mb='20px'>
										As Uber works through a huge amount of internal management turmoil.
									</Text>
									<Flex justifyContent='space-between' mt='auto'>
										<Button
											variant='outlineWhite'
											minW='110px'
											h='36px'
											fontSize='10px'
											px='1.5rem'>
											VIEW ALL
										</Button>
										<AvatarGroup size='xs'>
											<Avatar borderColor='#121241' name='Ryan Florence' src={avatar6} />
											<Avatar borderColor='#121241' name='Segun Adebayo' src={avatar2} />
											<Avatar borderColor='#121241' name='Kent Dodds' src={avatar3} />
											<Avatar borderColor='#121241' name='Prosper Otemuyiwa' src={avatar4} />
										</AvatarGroup>
									</Flex>
								</Flex>
							</Flex>
							<Flex direction='column'>
								<Box mb='20px' position='relative' borderRadius='20px'>
									<Image src={ProjectImage2} borderRadius='20px' />
								</Box>
								<Flex direction='column'>
									<Text fontSize='10px' color={'gray.400'} mb='10px'>
										Project #2
									</Text>
									<Text fontSize='xl' color='#fff' fontWeight='bold' mb='10px'>
										Scandinavian
									</Text>
									<Text fontSize='sm' color={'gray.400'} mb='20px'>
										Music is something that every person has his or her own specific opinion about.
									</Text>
									<Flex justifyContent='space-between' mt='auto'>
										<Button
											variant='outlineWhite'
											minW='110px'
											h='36px'
											fontSize='10px'
											px='1.5rem'>
											VIEW ALL
										</Button>
										<AvatarGroup size='xs'>
											<Avatar borderColor='#121241' name='Ryan Florence' src={avatar6} />
											<Avatar borderColor='#121241' name='Segun Adebayo' src={avatar2} />
											<Avatar borderColor='#121241' name='Kent Dodds' src={avatar3} />
											<Avatar borderColor='#121241' name='Prosper Otemuyiwa' src={avatar4} />
										</AvatarGroup>
									</Flex>
								</Flex>
							</Flex>
							<Flex direction='column' h='100%'>
								<Box mb='20px' position='relative' borderRadius='20px'>
									<Image src={ProjectImage3} borderRadius='20px' />
								</Box>
								<Flex direction='column'>
									<Text fontSize='10px' color={'gray.400'} mb='10px'>
										Project #3
									</Text>
									<Text fontSize='xl' color='#fff' fontWeight='bold' mb='10px'>
										Minimalist
									</Text>
									<Text fontSize='sm' color={'gray.400'} fontWeight='400' mb='20px'>
										Different people have different taste, especially various types of music.
									</Text>
									<Flex justifyContent='space-between' mt='auto'>
										<Button
											variant='outlineWhite'
											minW='110px'
											h='36px'
											fontSize='10px'
											px='1.5rem'>
											VIEW ALL
										</Button>
										<AvatarGroup size='xs'>
											<Avatar borderColor='#121241' name='Ryan Florence' src={avatar6} />
											<Avatar borderColor='#121241' name='Segun Adebayo' src={avatar2} />
											<Avatar borderColor='#121241' name='Kent Dodds' src={avatar3} />
											<Avatar borderColor='#121241' name='Prosper Otemuyiwa' src={avatar4} />
										</AvatarGroup>
									</Flex>
								</Flex>
							</Flex>
						</Grid>
					</CardBody>
				</Card>
			</Grid>
						*/}
		</Flex>
	);
}

export default Profile;
